import gql from "graphql-tag";

export const GET_REFFERAL = gql`
  query referral_programs($type: referral_type_enum, $user_id: uuid) {
    referral_programs(
      where: { type: { _eq: $type }, is_active: { _eq: true } }
    ) {
      id
      title
      description
      condition
      incentive
      start_date_time
      end_date_time
      type
      created_at
      updated_at
    }
    referral_invites_aggregate(where: { sent_by_user_id: { _eq: $user_id } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_REFFERAL_INVITE = gql`
  query referral_invites($user_id: uuid!, $limit: Int) {
    referral_invites(
      where: {
        sent_by_user_id: { _eq: $user_id }
        invitation_accepted_at: { _is_null: false }
      }
      limit: $limit
    ) {
      id
      referral_program {
        incentive
      }
    }
    referral_invites_aggregate(
      where: {
        sent_by_user_id: { _eq: $user_id }
        invitation_accepted_at: { _is_null: false }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
